import moment from "moment";
import { downloadRequest, getRequest, patchRequest } from "../utils/axiosUtils";
import { formatDate, formatStoredPhone, getFilterQuery, getStatusLabel } from "../utils/helperFunction";
import { API_URL } from "../config/config";

export const fetchAllReferralList = async (
  {
  setRows,
  filterData = {},
  setRowCount,
  setLoading
}) => {
  try {
    setLoading && setLoading(true)
    const query = getFilterQuery(filterData)
    const url = `${API_URL}/referral/admin/all${query}`;

    const response = await getRequest({url});

    if (response.status >= 200 && response.status < 300 && response.data) {
      const pagination = response.data?.pagination
      const options = (response.data?.data || []).map((item,idx) => ({
         sNo: (pagination?.page-1)*pagination.limit + (idx+1),
        id: item._id,
        referralID:item?.referralId || "-",
        referrerName:item?.referrer?.fullName || '-',
        friendsName: item?.fullName || '-',
        friendMobileNumber: item?.phone ? formatStoredPhone(item?.phone) : '-', 
        course: item?.courseInterest || '-',
        email: item?.email || '-',
        gender: item?.gender || '-',
        state: item?.state || '-',
        city: item?.city || '-',
        dob: item.dob ? moment(item.dob).format("DD/MM/YYYY") : '-',
        referredOnDate: item.createdAt ? moment(item.createdAt).format("DD/MM/YYYY") : '-',
        assignee:item?.counselorId ? `${item?.counselorId?.firstName || ""} ${item?.counselorId?.lastName || ""}`.trim() : "-",
        lastUpdatedOn: item.updatedAt ? moment(item.updatedAt).format("DD/MM/YYYY") : '-',
        notes: item?.notes || '-',
        status:item?.status ? getStatusLabel(item?.status) :  "-",
      }));

      setRows(options);
      setRowCount && setRowCount(response.data?.pagination?.total || 0)
    } else {
      setRows([])
      throw new Error(`Unexpected response code: ${response.status}`);
    }
  } catch (error) {
    console.error("fetchAllWebLeads error",error);
      setRows([])
     throw new Error(error?.response?.data?.message || 'Unknown error occurred');
  }finally{
    setLoading && setLoading(false)
  }
};

export const assignCounselorToReferral = async ({setSaving,payload}) => {
  try {
    const {_id,counselorId} = payload

    if (!_id || !counselorId) {
      throw new Error('Counseling ID, counselor ID are required')
    }
    setSaving && setSaving(true)
    const response = await patchRequest({
      url: `${API_URL}/referral/admin/assignCounselor`,
      data: { _id,counselorId},
    })
  
    if (response?.data?.success === false) {
      throw new Error(response.data.message || 'Failed to assign councelor')
    }
  
    return response.data
    
  } catch (error) {
      throw new Error(error?.response?.data?.message || `Failed to assign counselor`);
  }finally{
    setSaving && setSaving(false)
  }
}

export const saveReferralNotes = async ({setSaving,payload}) => {
  try {
    const {_id,notes,status} = payload

    if (!_id || !notes?.trim() || !status) {
      throw new Error('Referral ID, status and notes are required')
    }
    setSaving && setSaving(true)
    const response = await patchRequest({
      url: `${API_URL}/referral/admin/saveNotes`,
      data: payload,
    })
  
    if (response?.data?.success === false) {
      throw new Error(response.data.message || 'Failed to save notes')
    }
  
    return response.data
    
  } catch (error) {
      throw new Error(error?.response?.data?.message || `Failed to save notes`);
  }finally{
    setSaving && setSaving(false)
  }
}

export const downloadReferralList = async ({
  setDownloading,
  filterData={}
}) => {
  try {
    const query = getFilterQuery(filterData)
    const url = `${API_URL}/referral/admin/all${query}`

    setDownloading && setDownloading(true)
    const response = await downloadRequest({ url });

    if (response.status >= 200 && response.status < 300 && response.data) {
      const blob = new Blob([response?.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "referral.xlsx";
      link.click();
      window.URL.revokeObjectURL(url);
    } else {
      throw new Error(`Unexpected response code: ${response.status}`);
    }
  } catch (error) {
    console.error("downloadReferralList error", error);
    throw new Error(error?.response?.data?.message || `Failed to download`);
  } finally {
    setDownloading && setDownloading(false)
  }
};